import Vue from 'vue'

export default {
	getStudentAttainmentScore (classId) {
		return Vue.http.get('studentAttainmentScore/' + classId)
	}
}
